import { render, staticRenderFns } from "./BusinessPoint.vue?vue&type=template&id=02f2925a&scoped=true"
import script from "./BusinessPoint.vue?vue&type=script&lang=js"
export * from "./BusinessPoint.vue?vue&type=script&lang=js"
import style0 from "./BusinessPoint.vue?vue&type=style&index=0&id=02f2925a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f2925a",
  null
  
)

export default component.exports